/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Wrapped_Volume_DownInputs */

const en_us2_wrapped_volume_down = /** @type {(inputs: Wrapped_Volume_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% below the week before.`)
};

const pt_br2_wrapped_volume_down = /** @type {(inputs: Wrapped_Volume_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% abaixo da semana anterior.`)
};

const es_419_wrapped_volume_down = /** @type {(inputs: Wrapped_Volume_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% menos que la semana anterior.`)
};

const pt_pt2_wrapped_volume_down = /** @type {(inputs: Wrapped_Volume_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% abaixo da semana anterior.`)
};

const fr_fr2_wrapped_volume_down = /** @type {(inputs: Wrapped_Volume_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} % de moins que la semaine précédente.`)
};

const de_de2_wrapped_volume_down = /** @type {(inputs: Wrapped_Volume_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} % weniger als in der Woche davor.`)
};

const it_it2_wrapped_volume_down = /** @type {(inputs: Wrapped_Volume_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% in meno della settimana precedente.`)
};

/**
* | output |
* | --- |
* | "{pct}% below the week before." |
*
* @param {Wrapped_Volume_DownInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_volume_down = /** @type {((inputs: Wrapped_Volume_DownInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Volume_DownInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_volume_down(inputs)
	if (locale === "es-419") return es_419_wrapped_volume_down(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_volume_down(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_volume_down(inputs)
	if (locale === "de-DE") return de_de2_wrapped_volume_down(inputs)
	if (locale === "it-IT") return it_it2_wrapped_volume_down(inputs)
	return en_us2_wrapped_volume_down(inputs)
});
export { wrapped_volume_down as "wrapped.volume_down" }